import { derivedModeAccepted } from "./roofingV2ModeReasons";
import { copyRevisionSiblings } from "./roofingV2RevisionView";

export function applyReloadedEnvelope(envelope) {
  const settingsSource = envelope && envelope.settings;
  const derivedMode = derivedModeAccepted(envelope && envelope.derived_mode);
  if (!settingsSource || settingsSource.bot_type !== "roofing_v2" || !derivedMode) {
    return { accepted: false };
  }
  const settings = copyRevisionSiblings(settingsSource, envelope);
  delete settings.credential_refs;
  return { accepted: true, settings, derivedMode };
}

export function reloadOutcome(currentNotice, result) {
  if (result === "accepted") {
    return { notice: "", reloadProblem: "" };
  }
  if (result === "rejected") {
    return {
      notice: currentNotice,
      reloadProblem: "The server response was not accepted.",
    };
  }
  if (result === "failed") {
    return {
      notice: currentNotice,
      reloadProblem: "Settings could not be reloaded.",
    };
  }
  return { notice: currentNotice, reloadProblem: "" };
}
